import { observable, action, runInAction } from "mobx";
import UserLoginHistoriesApiService from "@api-services/user/UserLoginHistoriesApiService";
import { FailedLogin } from "@api-types/user/FailedLoginDataDto";
import { DateTime } from "luxon";
import { FailedLoginsReportFilter, FailedLoginReportMode } from "@data-types";
import { THEME_SETTINGS } from "@theme-settings";

export default class FailedLoginsCheckPopupStore {
	@observable isActive: boolean = false;
	@observable failedLoginData: FailedLogin[] | null = null;
	@observable isFetchingDataOnOpen: boolean = true;
	@observable reportFromDate: string | null = null;

	@action.bound
	async onInitialize(): Promise<void> {
		const reportFilter: FailedLoginsReportFilter = {
			reportMode: THEME_SETTINGS.failedLoginReport.reportMode,
			rpp:
				THEME_SETTINGS.failedLoginReport.queryLimit > 0
					? THEME_SETTINGS.failedLoginReport.queryLimit
					: 20,
		};

		if (
			reportFilter.reportMode === FailedLoginReportMode.FROM_INTERVAL_HOUR
		) {
			reportFilter.hourInterval =
				THEME_SETTINGS.failedLoginReport.queryIntervalInHours;
		}

		try {
			const data =
				await UserLoginHistoriesApiService.getUserFailedLogins(
					reportFilter
				);

			runInAction(() => {
				this.failedLoginData = data.failedLogins;
				this.reportFromDate = DateTime.fromISO(
					data.startDate
				).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
			});
		} catch (err) {
			console.error(err);
			//if data is null error message will be shown
		} finally {
			this.isFetchingDataOnOpen = false;
		}
	}

	@action.bound
	togglePopup(): void {
		this.isActive = !this.isActive;
	}

	@action.bound
	onDispose(): void {
		this.isActive = false;
		this.failedLoginData = null;
		this.isFetchingDataOnOpen = true;
		this.reportFromDate = null;
	}
}
